import { useTranslation } from 'react-i18next';

const Hero = ({ id }) => {
  const { t } = useTranslation();

  return (
    <section id={id} className="pt-32 pb-20 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto">
      <div className="flex flex-col md:flex-row items-center">
        <div className="md:w-1/2 mb-10 md:mb-0">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-4">
            {t('hero.greeting')} <span className="gradient-text">{t('hero.name')}</span>
          </h1>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-semibold mb-6">
            {t('hero.title')}
          </h2>
          <p className="text-lg text-gray-600 mb-8 max-w-lg">
            {t('hero.description')}
          </p>
          <div className="flex space-x-4">
            <a href="#contact" className="px-6 py-3 bg-gradient-to-r from-blue-500 to-purple-600 text-white rounded-lg font-medium hover:opacity-90 transition duration-300">
              {t('common.cta.contact')}
            </a>
            <a href="#projects" className="px-6 py-3 border border-gray-300 rounded-lg font-medium hover:bg-gray-100 transition duration-300">
              {t('common.cta.viewWork')}
            </a>
          </div>
        </div>
        <div className="md:w-1/2 flex justify-center">
          <div className="relative w-64 h-64 md:w-80 md:h-80 lg:w-96 lg:h-96">
            <div className="absolute inset-0 bg-gradient-to-r from-blue-400 to-purple-500 rounded-full opacity-20 blur-xl"></div>
            <div className="absolute inset-4 bg-gradient-to-r from-blue-500 to-purple-600 rounded-full flex items-center justify-center">
              <div className="w-full h-full rounded-full overflow-hidden border-4 border-white">
                <div className="w-full h-full bg-gray-200 flex items-center justify-center">
                  <img src="https://s.gravatar.com/avatar/5d494a162fd7d534b1e599afb2575e21?s=480&r=pg&d=https%3A%2F%2Fcdn.auth0.com%2Favatars%2Fwo.png" alt="ismaildev"/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
